import { render, staticRenderFns } from "./SetPrices.vue?vue&type=template&id=2d1cdd9b&scoped=true"
import script from "./SetPrices.vue?vue&type=script&lang=js"
export * from "./SetPrices.vue?vue&type=script&lang=js"
import style0 from "./SetPrices.vue?vue&type=style&index=0&id=2d1cdd9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1cdd9b",
  null
  
)

export default component.exports